
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit/museum-details/zagreb",
      function () {
        return require("private-next-pages/visit/museum-details/zagreb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit/museum-details/zagreb"])
      });
    }
  